import React, {useEffect, useState} from "react";
import {Grid, Button} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {Field, useFormikContext} from "formik";
import {usePolicyContext} from "./PolicyContext";
import RadioGroup from "@material-ui/core/RadioGroup";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import BankAccountNew from "./BankAccountNew";
import {ErrorCommon} from "../../formikFormInputs";
import {useActions} from "../../../actions";
import * as PaymentActions from "../../../actions/payment";
import {isAdmin} from "../../navigation/AdminNavigation";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers";

function BankAccountList(props: any) {
    const {policy, refetchPolicy}: any = usePolicyContext();
    const [policyNumber, setPolicyNumber] = useState("");
    const {user} = useSelector((state: RootState) => state.auth);
    console.log(user, "-------------------user status")
    const isServicing = user && user.accessType === "client" && user.demoClientId
    const [paymentMethods, setPaymentMethods] = useState([]);
    const { errors, touched} = useFormikContext();
    const [isConfirmed, setIsConfirmed] = useState<boolean>(false);
    const [isNewAccount, setIsNewAccount] = useState<boolean>(false);
    const [deletePaymentMethodId, setDeletePaymentMethodId] = useState<string>("");
    const {removePaymentMethod} = useActions(PaymentActions);
    const [scheduledPaymentMethodId, setScheduledPaymentMethodId] = useState("");

    useEffect(() => {
        if (policy && policy.policyNumber) {
            setPolicyNumber(policy.policyNumber);
            setPaymentMethods(policy.paymentMethods);
            if (policy.paymentSchedule) {
                setScheduledPaymentMethodId(policy.paymentSchedule.paymentMethodId)
            }
        }
    }, [policy]);


    const deletePaymentMethod = async () => {
        if (deletePaymentMethodId && scheduledPaymentMethodId !== deletePaymentMethodId) {
            const removePaymentMethodPayload = {
                policyNumber: policyNumber,
                recordKey: deletePaymentMethodId,
            };
            await removePaymentMethod(removePaymentMethodPayload);
            refetchPolicy();
            setDeletePaymentMethodId("");
            setIsConfirmed(false);
        } else {
            console.log("Scheduled Payment Method Cannot be deleted");
        }
    };

    const addPaymentMethod = () => {
        setIsNewAccount(true);
    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="body1" component="strong" className="mt20 floatLeft w100 mb0">Bank Account
                    Details
                    <Button
                          variant="text"
                          color="primary"
                          className={`floatRight mt15Small`}
                          style={{lineHeight: "27px"}}
                          onClick={addPaymentMethod}
                          disabled={isAdmin(user) || !!isServicing}
                    >
                        <AddCircleIcon className="floatLeft mr15"/> Add New Bank Account
                    </Button>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <RadioGroup name={"paymentMethodId"}>
                    {
                        paymentMethods.map((method: any, _index: number) => {
                            const notRemovable = (scheduledPaymentMethodId === method.recordKey) || !!isServicing;
                            return (<Grid container spacing={2}>
                                    <Grid item xs={8}>
                                        <label className="displayF">
                                            <Field disabled={isAdmin(user) || !!isServicing} type="radio" name="paymentMethodId" value={method.recordKey} style={{width:'20px',height:'20px',marginTop:'0'}}/>
                                            <span className="ml10">{method.bankName + " " + method.maskedAccountNumber}</span>
                                        </label>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <IconButton className={"floatRight"} onClick={() => {
                                            setIsConfirmed(true);
                                            setDeletePaymentMethodId(method.recordKey)
                                        }}
                                        disabled={notRemovable}
                                        >
                                            <DeleteIcon className={notRemovable ? "colorGrey" : "colorRed"}/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            );
                        })
                    }
                </RadioGroup>
                <ErrorCommon errors={errors}
                             name={"paymentMethodId"}
                             touched={touched} />
            </Grid>
            {isConfirmed &&
                <ConfirmationDialog
                    title={"Remove Bank Account"}
                    description={"Are you sure you want to remove this bank account?"}
                    isConfirmed={isConfirmed}
                    setIsConfirmed={setIsConfirmed}
                    action={()=>deletePaymentMethod()}
                />
            }
            {isNewAccount && <BankAccountNew setIsNewAccount={setIsNewAccount} isNewAccount={isNewAccount}/>}
        </Grid>
    );
}

export default BankAccountList;
